export const eventType = {
	OFFER_CONTENT: "select-content-ofertante",
	OFFER_EDIT: "select-content-edit-ofertante",
	OFFER_CONTENT_MOBILE: "select-content-mobile-ofertante"
};

export default eventType;